export default __webpack_public_path__ + "static/media/Bracers of Ferine Anger.eec0ecd1.jpg";